<template>
  <div class="containerwidth">

    <div class="manualsw">
      <b-button-group>
          <b-button id="manualsw1" :variant="btnvariant1" size="sm" type=button class="manualsw-cls" :disabled="tabname=='predict'" @click="swManual(0)">
            <b-icon icon="cloud-download"></b-icon>Preset
          </b-button>
          <b-button id="manualsw2" :variant="btnvariant2" size="sm" type=button class="manualsw-cls" :disabled="tabname=='predict'" @click="swManual(1)">
            <b-icon icon="upload"></b-icon>Upload
          </b-button>
          <b-button id="manualsw3" :variant="btnvariant3" size="sm" type=button class="manualsw-cls" :disabled="tabname=='predict'" @click="swManual(2)">
            <b-icon icon="tools"></b-icon>Manual
          </b-button>
      </b-button-group>
    </div>

    <br/>
    <b-card title="AI学習実践" no-body>
      <b-card-header header-tag="nav">
        <b-nav card-header tabs>
          <b-nav-item v-bind:active="tabname=='train'" @click="swTab(0)">AI学習（画像学習）</b-nav-item>
          <b-nav-item v-bind:active="tabname=='predict'" @click="swTab(1)">AI予測（画像判定）</b-nav-item>
        </b-nav>
      </b-card-header>

      <b-card-body class="text-center" v-show="tabname=='train'">

        <AiTrain ref="aitrain"></AiTrain>

      </b-card-body>

      <b-card-body class="text-center" v-show="tabname=='predict'">

        <AiPredict ref="aipredict"></AiPredict>

      </b-card-body>

      <div class="widthmax">
        <div class="floatleft footerword">© SOCINNO</div>
        <div class="floatright footerword">Powered by <a target="_blank" href="https://www.tensorflow.org/js/">TensorFlow.js</a></div>
      </div>
    </b-card>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import AiTrain from '@/components/AiTrain.vue'
import AiPredict from '@/components/AiPredict.vue'

export default {
  name: 'rootpage',
  data () {
    return {
      tabname: 'train'
    }
  },
  components: {
    AiTrain,
    AiPredict
  },
  computed: {
    ...mapState([ 'manualInputFlag', 'resultGraph' ]),
    btnvariant1 () {
      if (this.manualInputFlag === 0) {
        return 'info'
      } else {
        return 'outline-info'
      }
    },
    btnvariant2 () {
      if (this.manualInputFlag === 1) {
        return 'info'
      } else {
        return 'outline-info'
      }
    },
    btnvariant3 () {
      if (this.manualInputFlag === 2) {
        return 'info'
      } else {
        return 'outline-info'
      }
    }
  },
  methods: {
    swTab (swFlag) {
      // console.log('do swCamera')
      if (swFlag === 0) {
        this.tabname = 'train'
      } else {
        this.tabname = 'predict'
        // 判定グラフのX軸をInputの値で更新する
        this.$refs.aipredict.loadGraph()
      }
      this.$store.dispatch('setMessage', '') // メッセージ表示
    },
    swManual (swFlag) {
      // console.log('do swCamera')
      if (swFlag === 0) {
        this.$store.dispatch('manualSw', 0)
      } else if (swFlag === 1) {
        this.$store.dispatch('manualSw', 1)
      } else if (swFlag === 2) {
        this.$store.dispatch('manualSw', 2)
      }
    },
    async loadRootImage () {
      await this.$refs.aitrain.loadImage()
    },
    async loadRootGraph () {
      if (this.resultGraph.loss.length > 0) {
        await this.$refs.aitrain.loadGraph()
      }
      // await this.$refs.aipredict.loadGraph()
    },
    setMessage () {
      this.$refs.aitrain.loadImage()
    }
  }
}
</script>

<style scoped>
.containerwidth {
  position: relative;
  width: 1110px;
  min-width: 1110px;
  overflow: auto;
}
.manualsw {
  z-index: 6;
  position: absolute;
  top: 43px;
  left: 167px;
  width: 210px;
  height: 30px;
}
.manualsw-cls {
  padding: 0;
  margin: 0;
  width: 70px;
  height: 30px;
  font-size: 90%;
}
.footerword {
  margin: 10px;
  font-size: 80%;
}
li.nav-item:nth-child(1) > a.nav-link {
  padding: 8px 212px 8px 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/RootPage.vue